import { render, staticRenderFns } from "./addUpdate.vue?vue&type=template&id=977e1ed0"
import script from "./addUpdate.vue?vue&type=script&lang=js"
export * from "./addUpdate.vue?vue&type=script&lang=js"
import style0 from "./addUpdate.vue?vue&type=style&index=0&id=977e1ed0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports